import t1 from "assets/imgs/t1.webp";
import t2 from "assets/imgs/t2.webp";
import t3 from "assets/imgs/t3.webp";
import t4 from "assets/imgs/t4.webp";
import t5 from "assets/imgs/t5.webp";
import t6 from "assets/imgs/t6.webp";
import t7 from "assets/imgs/t7.webp";
import t8 from "assets/imgs/t8.webp";
import t9 from "assets/imgs/t9.webp";
import t10 from "assets/imgs/t10.webp";
import t11 from "assets/imgs/t11.webp";
import t12 from "assets/imgs/t12.webp";
import t13 from "assets/imgs/t13.webp";
import t14 from "assets/imgs/t14.webp";
import t15 from "assets/imgs/t15.webp";
import t16 from "assets/imgs/t16.webp";
import t17 from "assets/imgs/t17.webp";
import t18 from "assets/imgs/t18.jpg";
import t19 from "assets/imgs/t19.png";

export const Data = [
  {
    id: 1,
    image: t1,
    titleKey: "testimonials.sofia.title",
    positionKey: "testimonials.sofia.position",
    descriptionKey: "testimonials.sofia.description",
    rating: 5,
  },
  {
    id: 2,
    image: t2,
    titleKey: "testimonials.shavkatof_husniddin.title",
    descriptionKey: "testimonials.shavkatof_husniddin.description",
    rating: 4,
    positionKey: "testimonials.shavkatof_husniddin.position",
  },
  {
    id: 3,
    image: t18,
    titleKey: "testimonials.eldor_dustov.title",
    descriptionKey: "testimonials.eldor_dustov.description",
    rating: 3,
    positionKey: "testimonials.eldor_dustov.position",
    audioUrl:
      "https://www.dropbox.com/scl/fi/jau2ni9xc4w0zjexpwgaj/audio_2026-02-03_21-53-01.ogg?rlkey=mbg6nz6bxd0jgsb2k8g3dvgfq&st=8g86czck&raw=1",
  },
  {
    id: 4,
    image: t3,
    titleKey: "testimonials.tulaganov_fathulla.title",
    descriptionKey: "testimonials.tulaganov_fathulla.description",
    rating: 3,
    positionKey: "testimonials.tulaganov_fathulla.position",
  },
  {
    id: 5,
    image: t19,
    titleKey: "testimonials.zulfiya_abduazizova.title",
    rating: 5,
    descriptionKey: "testimonials.zulfiya_abduazizova.description",
    positionKey: "testimonials.zulfiya_abduazizova.position",
    audioUrl:
      "https://www.dropbox.com/scl/fi/zkulajf02qgvqkawi240s/Zulfiya.ogg?rlkey=cpj0lcialm275g895rke329fr&st=jjh3qv6e&raw=1",
  },
  {
    id: 6,
    image: t4,
    titleKey: "testimonials.rustamov_javohir.title",
    descriptionKey: "testimonials.rustamov_javohir.description",
    rating: 5,
    positionKey: "testimonials.rustamov_javohir.position",
  },
  {
    id: 7,
    image: t5,
    titleKey: "testimonials.jony1.title",
    descriptionKey: "testimonials.jony1.description",
    rating: 4.5,
    positionKey: "testimonials.jony1.position",
  },
  {
    id: 8,
    image: t6,
    titleKey: "testimonials.sarah.title",
    descriptionKey: "testimonials.sarah.description",
    rating: 3.5,
    positionKey: "testimonials.sarah.position",
  },
  {
    id: 9,
    image: t7,
    titleKey: "testimonials.jony2.title",
    descriptionKey: "testimonials.jony2.description",
    rating: 4,
    positionKey: "testimonials.jony2.position",
  },
  {
    id: 10,
    image: t8,
    titleKey: "testimonials.mechail.title",
    descriptionKey: "testimonials.mechail.description",
    rating: 5,
    positionKey: "testimonials.mechail.position",
  },
  {
    id: 11,
    image: t9,
    titleKey: "testimonials.durdona_ikromova.title",
    descriptionKey: "testimonials.durdona_ikromova.description",
    rating: 4.5,
    positionKey: "testimonials.durdona_ikromova.position",
  },
  {
    id: 12,
    image: t10,
    titleKey: "testimonials.earl.title",
    descriptionKey: "testimonials.earl.description",
    rating: 5,
    positionKey: "testimonials.earl.position",
  },
  {
    id: 13,
    image: t11,
    titleKey: "testimonials.dilshoda.title",
    descriptionKey: "testimonials.dilshoda.description",
    rating: 5,
    positionKey: "testimonials.dilshoda.position",
  },
  {
    id: 14,
    image: t12,
    titleKey: "testimonials.abduvali_kozimov.title",
    descriptionKey: "testimonials.abduvali_kozimov.description",
    rating: 5,
    positionKey: "testimonials.abduvali_kozimov.position",
  },
  {
    id: 15,
    image: t13,
    titleKey: "testimonials.davron_hojiqurbonov.title",
    descriptionKey: "testimonials.davron_hojiqurbonov.description",
    rating: 4.5,
    positionKey: "testimonials.davron_hojiqurbonov.position",
  },
  {
    id: 16,
    image: t14,
    titleKey: "testimonials.yaxshiboyeva_maxliyo.title",
    descriptionKey: "testimonials.yaxshiboyeva_maxliyo.description",
    rating: 5,
    positionKey: "testimonials.yaxshiboyeva_maxliyo.position",
  },
  {
    id: 17,
    image: t15,
    titleKey: "testimonials.shodmonov_jonibek.title",
    descriptionKey: "testimonials.shodmonov_jonibek.description",
    rating: 4.5,
    positionKey: "testimonials.shodmonov_jonibek.position",
  },
  {
    id: 18,
    image: t16,
    titleKey: "testimonials.bozorova_gulnora.title",
    descriptionKey: "testimonials.bozorova_gulnora.description",
    rating: 5,
    positionKey: "testimonials.bozorova_gulnora.position",
  },
  {
    id: 19,
    image: t17,
    titleKey: "testimonials.dmitriy_sergeevich.title",
    descriptionKey: "testimonials.dmitriy_sergeevich.description",
    rating: 4.5,
    positionKey: "testimonials.dmitriy_sergeevich.position",
  },
];
